// extracted by mini-css-extract-plugin
export default {"card":"Dg_inUop","alert":"sPMaCmpo","details":"P2cE7_mp","row":"d3ulaiaC","label":"HHFZZpdk"};